<div class="contact-wrapper">
  <section>
    <h1>{{ i18n.contact.social }}</h1>
    <p innerHtml="{{ i18n.contact.subtext }}"></p>
  </section>
  <section class="contact-items">
    <ul>
      <li>
        <a href="https://www.instagram.com/nura.pix/" target="blank">
          <img src="../../../assets/img/icons/031-deadline.svg" alt="" />
          <hr />
          <div innerHtml="{{ i18n.contact.insta }}"></div>
        </a>
      </li>
      <li>
        <a href="mailto:nuraray.art@gmail.com" target="blank">
          <img src="../../../assets/img/icons/030-message.svg" alt="" />
          <hr />
          <div innerHtml="{{ i18n.contact.mail }}"></div>
        </a>
      </li>
      <li>
        <a href="https://twitter.com/nuraray_pix" target="blank">
          <img src="../../../assets/img/icons/001-painting.svg" alt="" />
          <hr />
          <div innerHtml="{{ i18n.contact.twitter }}"></div>
        </a>
      </li>
    </ul>
  </section>
</div>
